<template>
  <lu-vbox lu-fullsize lu-flex class='changepwd-container'>
    <spinner ref='spinner'/>

    <lu-item><PageHeader :title=' $t("Change of password") ' :hasList='false' :hasReload='false' /></lu-item>

    <el-form ref='form' :model='form' label-width="180px" sclass='lu-flex lu-flex-wrap'>
        <lu-vbox lu-hcenter class='page vpad-in-20' sstyle='font-size: 0.9rem; padding: 30px;' >
          <el-form-item :label='$t("Your password")' prop='oldPwd' :rules="oldPwdRule">
            <el-input type="password" v-model='form.oldPwd' />
          </el-form-item>
          <el-form-item :label='$t("New password")' prop='newPwd' :rules="newPwdRule">
            <el-input type="password" v-model='form.newPwd' />
          </el-form-item>
          <el-form-item :label='$t("Confirm new password")' prop='confirmPwd' :rules="confirmPwdRule">
            <el-input type="password" v-model='form.confirmPwd' />
          </el-form-item>
        </lu-vbox>
    </el-form>

    <lu-hbox lu-hcenter class='mar-t-10 pad-in-5'>
      <lu-item><el-button class='button' icon='el-icon-check' @click="submitForm()">{{ $t('Change') }}</el-button></lu-item>
      <lu-item><el-button class='button' icon='el-icon-close' @click="returnLogin">{{ $t('cancel') }}</el-button></lu-item>
    </lu-hbox>

  </lu-vbox>
</template>

<script>
import { LuVbox, LuHbox, LuItem } from 'lusis-ui'
import PageHeader from '@/components/PageHeader'
import Spinner from '@/components/Spinner'
import messageHandler from '@/mixins/message'
import { mapGetters } from 'vuex'

export default {
  name: 'ChangePassword',
  mixins: [ messageHandler ],
  props: [ 'userLogin' ],
  components: { Spinner, LuVbox, LuHbox, LuItem, PageHeader },
  methods: {
    validatePassword (rule, value, cb) {
      if (this.form.password2 !== '') {
        this.$refs.form.validateField('confirmPwd')
      }
      cb()
    },
    validateConfirmPassword (rule, value, cb) {
      if (value === '') {
        cb(new Error('Please input the password again'))
      }
      else if (value !== this.form.newPwd) {
        cb(new Error('Passwords does not match!'))
      }
      else {
        cb()
      }
    },
    returnLogin: function () {
      this.$store.commit('user/needToChangePassword', false)
      this.logout()
      // eslint-disable-next-line handle-callback-err
      // this.$router.push('/login').catch(err => {})
    },
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let cond = {
            login: this.userLogin,
            oldPwd: this.form.oldPwd,
            password: this.form.newPwd,
            confirmPwd: this.form.confirmPwd
          }
          this.$tango.changePassword(cond).then(rep => {
            if (rep.resultCode === 0) {
              this.$refs.spinner.hide()
              this.$message({
                type: 'success',
                message: this.$t('Password has been successfully changed')
              })

              this.$store.dispatch('user/login', rep)
              this.$store.dispatch('permission/GenerateRoutes', { roles: this.userPermission, isAdmin: this.isAdmin })
              this.$router.matcher.addRoutes(this.addedRouters)
              // eslint-disable-next-line handle-callback-err
              this.$router.push({ path: this.redirect || '/' }).then(() => this.$store.commit('user/needToChangePassword', false))
            }
            else {
              throw new Error('Failed to change password')
            }
          }).catch(err => {
            this.$message({
              type: 'error',
              message: err.message
            })
          })
        }
      })
    }
  },
  computed: {
    ...mapGetters( [ 'userPermission', 'isAdmin', 'addedRouters' ] ),
  },
  data: function () {
    return {
      form: {
        oldPwd: null,
        newPwd: null,
        confirmPwd: null
      },
      oldPwdRule: [{ required: true, message: 'Please input current password', trigger: ['blur', 'change'] }],
      newPwdRule: [
        { validator: this.validatePassword },
        { required: true, message: 'Please input new password', trigger: ['blur', 'change'] }
      ],
      confirmPwdRule: [
        { validator: this.validateConfirmPassword },
        { required: true, message: 'Please input confirm new password', trigger: ['blur', 'change'] }
      ]
    }
  }
}
</script>

<style lang='scss' scoped>
.changepwd-container {
  margin: 10px;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 10px;

  .el-form-item {
    width: 400px !important;
  }
}

.page {
  padding: 20px;
}
</style>
